import { createApp } from 'vue';
import { createPinia } from 'pinia';
import OpenLayersMap from 'vue3-openlayers';
import { createVuetify, createRouter, createI18n, setErrorHandlers } from '@core';
import { FormDefaultAttributes } from '@common';
import { createAuthGuard } from '@shared';
import { initForms, useModulesConfigStore } from '@maximap-base';
import themes from './app/themes';
import routes from './app/routes';
import messages from './i18n';
import { getAppConfig } from './modules.config';
import App from './App.vue';
import './assets/scss/styles.scss';

FormDefaultAttributes.setFormDefaultAttributes({
  density: 'compact',
  color: 'primary',
  variant: 'solo'
});

const app = createApp(App);
setErrorHandlers(app);

const pinia = createPinia();
const router = createRouter(routes);
const i18n = createI18n('hu', messages);
const vuetify = createVuetify(i18n, themes, {
  VTextField: {
    variant: 'solo',
    density: 'compact',
    color: 'primary'
  },
  VSelect: {
    variant: 'solo',
    density: 'compact',
    color: 'primary'
  }
});

initForms();

app.use(pinia);

const moduleConfigStore = useModulesConfigStore();
moduleConfigStore.setModuleConfig(getAppConfig);

createAuthGuard(router, 'login');

app.use(router);
app.use(i18n);
app.use(vuetify);
app.use(OpenLayersMap);
app.mount('#app');
